import React, { useState } from 'react';
import styles from './Login.module.scss';
import { useNavigate } from 'react-router-dom';
import logo from '../../images/login-logo-n.svg'; // Add your logo
import groklogo from '../../images/login-footer-logo.svg';
import { setAuth } from '../../utils/auth';

const Login: React.FC = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        
        const authToken = 'auth-token-' + Date.now();
        setAuth(authToken);
        navigate('/dashboard');
    };


      const currentYear = new Date().getFullYear();
    return (
        <div className={`${styles.loginBg} d-flex justify-content-center align-items-center`}>
            <div className={`${styles.cardContainer} card shadow-lg`}>
                <div className="card-body text-center">
                    <img src={logo} alt="Company Logo" className={styles.logo} />
                    <h5 className="mt-3">Login to your account</h5>
                    <form onSubmit={handleLogin}>
                        <input
                            type="text"
                            className="form-control mt-4"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            className="form-control mt-3"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button type="submit" className="btn btn-primary w-100 mt-5">
                            Login
                        </button>
                    </form>
                </div>
            </div>

            <div className={styles.poweredBy}>
                <span style={{ display: "flex", justifyContent: "center", gap: "8px", color: "#fff", marginBottom: "6px" }}>
                    powered by <img src={groklogo} alt="footer Logo" />
                </span>
                <span style={{ display: "flex", justifyContent: "center", gap: "8px", color: "#fff" }}>
                    Copyright © {currentYear} 
                </span>
            </div>
        </div>
    );
};

export default Login;


// import React from 'react';
// import styles from './Login.module.scss';
// import { useNavigate } from 'react-router-dom';

// const Login: React.FC = () => {
//     const navigate = useNavigate();

//     const handleLogin = () => {
//         // Dummy login logic
//         navigate('/dashboard');
//     };

//     return (
//         <div className={styles.loginContainer}>
//             <h2>Login Page</h2>
//             <button onClick={handleLogin}>Login</button>
//         </div>
//     );
// };

// export default Login;
